<div class="row column amount-image" *ngIf="amountImages.length > 0">
	<label [class.hidden]="minimumValue > (donation.amount * 1)">{{ 'amount.image.label' | translate }}</label>
	<div class="image-wrapper" [class.hidden]="minimumValue > (donation.amount * 1)" #imageWrapper>
		<ng-container *ngFor="let image of amountImages; let i = index">
			<img (load)="onImageLoad()" *ngIf="i === 0" [src]="imageDirecory + '/' + image.image" alt="" [class.visible]="(donation.amount * 1) >= image['minimum']" [class.hidden]="(amountImages[i+1]) && ((donation.amount * 1) >= amountImages[i+1]['minimum'])">
			<img [src]="imageDirecory + '/' + image.image" *ngIf="i > 0" alt="" [class.visible]="(donation.amount * 1) >= image['minimum']" [class.hidden]="(amountImages[i+1]) && ((donation.amount * 1) >= amountImages[i+1]['minimum'])">
		</ng-container>
	</div>
</div>
